import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

let INGREDIENTS_PRICE = null;
const initialState = {
	ingredients: null,
	totalPrice: 4,
	error: false,
	building: false,
};

const addIngredient = (state, action) => {
	const updatedIngredient = {
		[action.ingredient]: state.ingredients[action.ingredient] + 1,
	};
	const updatedIngredients = updateObject(state.ingredients, updatedIngredient);
	const updatedState = {
		ingredients: updatedIngredients,
		totalPrice: state.totalPrice + INGREDIENTS_PRICE[action.ingredient],
		building: true,
	};
	return updateObject(state, updatedState);
};

const removeIngredient = (state, action) => {
	const updatedIngredient = {
		[action.ingredient]: state.ingredients[action.ingredient]
			? state.ingredients[action.ingredient] - 1
			: 0,
	};
	const updatedIngredients = updateObject(state.ingredients, updatedIngredient);
	const updatedState = {
		ingredients: updatedIngredients,
		totalPrice: state.ingredients[action.ingredient]
			? state.totalPrice - INGREDIENTS_PRICE[action.ingredient]
			: state.totalPrice,
		building: true,
	};
	return updateObject(state, updatedState);
};

const setIngredient = (state, action) => {
	INGREDIENTS_PRICE = action.ingPrices;
	return updateObject(state, {
		ingredients: {
			salad: action.ingredients.salad,
			bacon: action.ingredients.bacon,
			cheese: action.ingredients.cheese,
			meat: action.ingredients.meat,
		},
		totalPrice: 4,
		error: false,
		building: false,
	});
};

const fetchIngredientsFailed = (state, action) => {
	return updateObject(state, { error: true, building: false });
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.ADD_INGREDIENTS:
			return addIngredient(state, action);

		case actionTypes.REMOVE_INGREDIENTS:
			return removeIngredient(state, action);

		case actionTypes.SET_INGREDIENTS_AND_PRICE:
			return setIngredient(state, action);

		case actionTypes.FETCH_INGREDIENTS_FAILED:
			return fetchIngredientsFailed(state, action);

		default:
			return state;
	}
};

export default reducer;
